module.exports = __webpack_public_path__ + "static/media/nav_menu.c9cd0c0c.svg";